<div class="section_header">
  <div class="section_header_title">
    <h2>Estatísticas</h2>
    <div class="section_header_buttons">
      <a class="btn-back" onclick="window.history.back()"><fa-icon [icon]="['fas','chevron-left']"></fa-icon> Voltar</a>
    </div>
  </div>
</div>

<div *ngIf="model" [@loadedHeightAnimation]="'visible'" class="highlights row-4-2">
  <div class="col">
    <div class="card">
      <div class="card-title uppercase">
        NÚMERO DE PEDIDO
      </div>
      <div class="card-body mt-3">
        {{model.NumPedido}}
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card">
      <div class="card-title uppercase">
        DATA ENVIO
      </div>
      <div class="card-body text-sm mt-3">
        {{model.SendDate |date:'medium' }}
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card">
      <div class="card-title uppercase">
        CAMPANHAS
      </div>
      <div class="card-body text-sm mt-3">
        {{model.CampaignName}}
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card">
      <div class="card-title uppercase">
        MEIO
      </div>
      <div class="card-body text-sm mt-3">
        {{model.MedioName}}
      </div>
    </div>
  </div>
</div>

<div class="highlights-2 row-4-1 my-4">
  <div *ngIf="totalMailsSent" [@loadedHeightAnimation]="'visible'" class="col">
    <div class="card border-orange">
      <div class="card-title">
       TOTAL CONTACTOS
      </div>
      <div class="card-body">
        {{ totalMailsSent.y }}
      </div>
    </div>
  </div>
  <div *ngIf="totalBajas" [@loadedHeightAnimation]="'visible'" class="col">
    <div class="card">
      <div class="card-title">
        Baixas
      </div>
      <div class="card-body">
        {{totalBajas.y}}
      </div>
    </div>
  </div>
  <div *ngIf="totalErrores" [@loadedHeightAnimation]="'visible'" class="col">
    <div class="card">
      <div class="card-title">
        Erros
      </div>
      <div class="card-body">
        {{totalErrores.y}}
      </div>
    </div>
  </div>
</div>

<hr class="orange ">
<div class="h4 orange" *ngIf="model && model.IdSendType==2 ">E-MAILS</div>
<div class="h4 orange" *ngIf="model && model.IdSendType==1 ">SMS</div>

<div class="highlights-2 row-3-1-lg my-4">
  <!--top Ultimas actualizaciones-->
  <div class="col chart-container">
    <div class="card p-2 bg-darkgrey">
      <div *ngIf="totalEntregados" [@loadedHeightAnimation]="'visible'" class="card-title">
        {{ totalEntregados.name }}
      </div>
      <div *ngIf="totalEntregados" [@loadedHeightAnimation]="'visible'" class="card-body">
        {{totalEntregados.y}}
      </div>
    </div>
    <div id="MailsSend" class="chart-inner-container">
      <div class="loading">
        <img src="assets/images/icons/ico_loading_bar.svg" />
      </div>
    </div>
  </div>
  <!--top Accesos Directos-->
  <div [hidden]="model && model.IdSendType==1" class="col chart-container">
    <div class="card p-2 bg-darkgrey">
      <div *ngIf="totalAbiertos" [@loadedHeightAnimation]="'visible'" class="card-title">
        {{ totalAbiertos.name }}
      </div>
      <div *ngIf="totalAbiertos" [@loadedHeightAnimation]="'visible'" class="card-body">
        {{totalAbiertos.y}}
      </div>
    </div>
    <div id="MailsOpened" class="chart-inner-container">
      <div class="loading">
        <img src="assets/images/icons/ico_loading_bar.svg" />
      </div>
    </div>
  </div>
  <!--top Carousel-->
  <div [hidden]="model && model.IdSendType==1" class="col chart-container">
    <div class="card p-2 bg-darkgrey">
      <div *ngIf="totalClickeados" [@loadedHeightAnimation]="'visible'" class="card bg-darkgrey inner-card">
        <div class="card-title">
          {{ totalClickeados.name }}
        </div>
        <div class="card-body">
          {{totalClickeados.y}}
        </div>
      </div>
      <div *ngIf="distinctClicks" [@loadedHeightAnimation]="'visible'" class="card bg-darkgrey inner-card">
        <div class="card-title">
          Clicks únicos
        </div>
        <div class="card-body">
          {{distinctClicks.y}}
        </div>
      </div>
    </div>
    <div id="MailsClick" class="chart-inner-container">
      <div class="loading">
        <img src="assets/images/icons/ico_loading_bar.svg" />
      </div>
    </div>
  </div>
</div>

<div class="row row-3-1-lg mb-5" *ngIf="model && model.IdSendType==2">
  <div class="col">
    <table class="devices">
      <thead>
        <tr>
          <th colspan="2">INFORMAÇÃO DE ACESSO ATRAVÉS DE DISPOSITIVOS</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let device of devices">
          <td width="85%">{{device.Device}}</td>
          <td width="15%" class="text-center"><strong>{{device.Num}}</strong></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>